import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Pagination, Navigation, Autoplay } from "swiper/modules";
import { FaStar } from "react-icons/fa";
import "./Testimonials.css";

const testimonials = [
  {
    name: "Aarav Mehta",
    role: "Cloud Architect",
    image: "/Image/team-2.jpg",
    text: "“Narayani Solutions helped us migrate seamlessly to Microsoft Azure. Their architecture and execution were flawless and highly efficient.”"
  },
  {
    name: "Riya Sharma",
    role: "UI/UX Designer",
    image: "/Image/team-1.jpg",
    text: "“Working with Narayani Solutions design team was a great experience. They delivered a user interface that’s both modern and user-friendly.”"
  },
  {
    name: "Pooja Jadhav",
    role: "DevOps Engineer",
    image: "/Image/team-3.jpg",
    text: "“Their cloud automation services drastically improved our deployment speed. Narayani Solutions truly knows how to implement Azure DevOps right.”"
  },
  {
    name: "Ishita Rao",
    role: "Mobile App Developer",
    image: "/Image/testimonial3.jpg",
    text: "“Narayani Solutions built our mobile application from scratch and nailed every detail. Performance and design are top tier.”"
  },
  
];


const Testimonials = () => {
  return (
    <div className="testimonials-container1">
      <div style={{ textAlign: "center" }}></div>
      <h2 className="title">Client Reviews</h2>
      <Swiper
        spaceBetween={30}
        pagination={{ clickable: true }}
        navigation={true}
        loop={true}
        autoplay={{ delay: 3000, disableOnInteraction: false }}
        modules={[Pagination, Navigation, Autoplay]}
        className="testimonial-slider"
        breakpoints={{
          320: { slidesPerView: 1, spaceBetween: 10 }, // 👈 1 card for mobile
          480: { slidesPerView: 1, spaceBetween: 20 }, // 👈 1 card for mobile
          768: { slidesPerView: 2, spaceBetween: 30 }, // 2 cards for tablet
          1024: { slidesPerView: 3, spaceBetween: 30 }, // 3 cards for desktop
        }}
      >
        {testimonials.map((testimonial, index) => (
          <SwiperSlide key={index}>
            <div className="testimonial-card1">
              <blockquote>{testimonial.text}</blockquote>
              <div className="author-info">
                <img src={testimonial.image} alt={testimonial.name} />
                <h3>{testimonial.name}</h3>
                <p>{testimonial.role}</p>
                <div className="star-rating">
                  {[...Array(5)].map((_, i) => (
                    <FaStar key={i} className="star" />
                  ))}
                </div>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default Testimonials;
